module.exports = __webpack_public_path__ + "static/media/laryngectomie_image_presentation.587e575e.png";